import { useMutation } from "@tanstack/react-query";

import { parseAwsUploadResponse } from "./transformers";
import { AwsUpload } from "./types";

export const useUpload = () => {
  return useMutation<string, Error, AwsUpload>({
    mutationFn: async ({ fields, file, url }) => {
      if (!file) {
        throw new Error("The file has not been provided.");
      }
      const body = new FormData();
      for (const key in fields) {
        if (Object.hasOwn(fields, key)) {
          body.append(key, fields[key]);
        }
      }
      body.append("file", file);
      const res = await fetch(url, { method: "post", body });
      return await parseAwsUploadResponse(res);
    },
  });
};
